import { Button, Icon, Link, SimpleGrid, Text, VStack } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import Container from "../components/Container";
import { BlogPost, BlogSection } from "../const/types";
import { ArrowUpRight } from "@phosphor-icons/react";
import cr from "../lib/request";
import ComponentSpinner from "../components/ComponentSpinner";
import BlogPostCard from "../components/blogComponents/BlogPostCard";
import EditableContent from "../components/landingPageComponents/EditableContent";

type Props = {
  preData: BlogSection;
};

export default function Blog({ preData }: Props) {
  const [data, setData] = useState<BlogPost[] | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  useEffect(() => {
    setLoading(true);
    const url = "api/blog/post/allpostlistpublic";
    cr.get(url)
      .then((r) => {
        if ((r.status = 200)) {
          setData(r.data.data);
        }
      })
      .catch((e) => {
        console.log(e);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  return (
    <VStack id="blogSection" py={20} align={"flex-start"}>
      {!loading && data ? (
        <Container>
          <VStack mb={12}>
            <EditableContent kontenId={preData.judul.id}>
              <Text
                textAlign={"center"}
                fontSize={[32, null, 34]}
                fontWeight={800}
              >
                {preData?.judul.konten}
              </Text>
            </EditableContent>
          </VStack>

          <SimpleGrid columns={[1, null, 2, 3]} gap={4}>
            {data?.map((content, i) => (
              <BlogPostCard key={i} data={content} />
            ))}
          </SimpleGrid>

          <VStack mt={8} align={"flex-end"}>
            <EditableContent kontenId={preData.linkAllBlog.id}>
              <Button
                w={"max-content"}
                variant={"ghost"}
                rightIcon={
                  <Icon
                    as={ArrowUpRight}
                    fontSize={[18, null, 20]}
                    weight="bold"
                  />
                }
                color={"p.500"}
                as={Link}
                isExternal
                href={preData?.linkAllBlog.konten}
                alignSelf={"flex-end"}
              >
                Jelajahi Semua Blog Kubu.id
              </Button>
            </EditableContent>
          </VStack>
        </Container>
      ) : (
        <ComponentSpinner />
      )}
    </VStack>
  );
}
